<template lang="pug">
v-card(width="100%" :class="{ 'ma-3' : $vuetify.breakpoint.smAndUp && !processInfoDialog }")
  v-toolbar.transparent(flat card :dense="!$vuetify.breakpoint.smAndUp")
    v-tooltip(bottom)
      v-btn.my-0(icon @click="back" slot="activator")
        v-icon() arrow_back
      span {{ $tf("fileUploader.back") }}
    v-toolbar-title.ml-0.task-toolbar-title
      v-avatar(size="40")
        v-icon.white--text.process-default-icon(:class="processDefinitionId.split(':')[0]")
      ul
        li {{ getTitle() }}
        li.body-2.grey--text()
          slot(name="header") {{ $tf("drawer.process.processInformation") }}
    v-spacer
    v-menu(bottom left)
      v-btn(slot="activator" icon)
        v-icon more_vert
      v-list
        v-list-tile(@click="diagram = true")
          v-list-tile-title {{ $tf("task.showDiagram") }}
  v-divider
  v-card-text(:class="{ 'px-0' : $vuetify.breakpoint.xsOnly }")
    v-container.p-r(fluid grid-list-xl :class="[ !$vuetify.breakpoint.xsOnly ? 'pt-2' : 'pt-0' ]")
      slot
      br
      v-divider
      v-layout(column wrap)
        v-list.v-list-responsive.overflow-x-hidden(three-line)
          v-subheader История задач
          template(v-for='(task, index) in tasks')
            v-list-tile.my-2(:key='task.id' avatar :class="[ task.endTime ? 'task-status-closed' : 'task-status-open']")
              v-list-tile-content
                v-list-tile-title {{ index+1 }}. {{ $tf(`${processDefinitionId.split(':')[0]}._process.task.${task.taskDefinitionKey}`, task.name) }}
                v-list-tile-sub-title
                  v-layout.mb-2(row wrap)
                    v-flex.pl-2.pb-0(xs12 sm3)
                      v-tooltip(top disabled=true)
                        template(v-slot:activator="{ on }")
                          v-chip.task-status(disabled v-on="on" :color="task.endTime ? 'blue-grey darken-1' : 'green'" text-color="white")
                            v-avatar
                              v-icon {{ task.endTime ? 'check_circle' : 'play_circle_filled' }}
                            | {{ task.endTime ? $tf("task.completed") : $tf("task.inProgress") }}
                        //- span Статус задачи
                    v-flex.pl-2.pb-0(xs12 sm4)
                      v-tooltip(top disabled=true)
                        template(v-slot:activator="{ on }")
                          v-chip.task-status(disabled v-on="on" :color="task.endTime ? 'blue-grey darken-1' : 'green'" text-color="white")
                            v-avatar
                              v-icon account_circle
                            span(v-if="task.assignee") {{ task.assignee.displayName }}
                            span(v-else style="text-decoration: underline;" @click="openCandidatesDialog(task.candidates)") {{ $tf("task.candidateGroups") }}
                        //- span Исполнитель задачи
                    v-flex.pl-2.pb-0(xs12 sm5)
                      v-tooltip(top disabled=true)
                        template(v-slot:activator="{ on }")
                          v-chip.task-status(disabled v-on="on" :color="task.endTime ? 'blue-grey darken-1' : 'green'" text-color="white")
                            v-avatar
                              v-icon access_time
                            | {{ $moment(task.startTime).format('DD.MM.YYYY HH:mm') }} {{ task.endTime ? ` - ${$moment(task.endTime).format('DD.MM.YYYY HH:mm')}` : '' }}
                        //- span Дата начала и завершения задачи
            v-divider

  wf-process-diagram(v-model="diagram" :processDefinitionId="processDefinitionId" :processDefinitionName="processDefinitionName" :processVariables="variables")

  v-dialog(v-model="candidatesDialog" scrollable max-width="80%")
    v-card
      v-card-title.subheading {{ $tf("task.candidateGroups") }}
      v-divider
      v-card-text
        v-list(two-line)
          template(v-for="(candidates, cindex) in candidatesList")
            v-subheader {{ candidates.name ? candidates.name : $tf("task.noGroups") }}
            template(v-for='(user, uindex) in candidates.users')
              v-list-tile(avatar)
                v-list-tile-avatar(size="46")
                  img(src="/static/icons/avatar_noname.png")
                v-list-tile-content
                  v-list-tile-title {{ user.displayName }}
                  v-list-tile-sub-title {{ user.id }}
      v-divider
      v-card-actions
        v-spacer
        v-btn(color="primary" flat @click="closeCandidatesDialog") {{ $tf("process.deploy.close") }}

</template>

<script>
import lodash from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import ProcessDiagram from '@/components/process/ProcessDiagram'

export default {
  name: 'ProcessStartTemplate',

  components: {
    'wf-process-diagram': ProcessDiagram,
  },

  data() {
    return {
      candidatesList: null,
      candidatesDialog: false,

      diagram: false,
      processDefinitionId: null,
      processDefinitionName: null,
    }
  },

  computed: {
    ...mapGetters({
      definition: 'process/definition',
      style: 'process/style',
      tasks: 'process/tasks',
      variables: 'process/variables',
      processInfoDialog: 'process/processInfoDialog',
    }),
  },

  created() {
    if (this.style) {
      this.styleElement = document.createElement('style')
      this.styleElement.type = 'text/css'
      this.styleElement.innerText = this.style
      document.head.appendChild(this.styleElement)
    }

    this.processDefinitionId = this.definition.id
    this.processDefinitionName = this.definition.name
  },

  beforeDestroy() {
    if (this.styleElement) {
      document.head.removeChild(this.styleElement)
    }
  },

  methods: {
    ...mapActions({
      toggleProcessInfoDialog: 'process/toggleProcessInfoDialog',
    }),

    getTitle() {
      const businessKey = this.variables._businessKey ? this.variables._businessKey.value : null
      const titleBusinessKey = businessKey ? `- ${businessKey}` : ''
      return `${this.processDefinitionName} ${titleBusinessKey}`
    },

    openCandidatesDialog(candidates) {
      this.candidatesList = lodash.orderBy(candidates, [item => item.name], 'asc')
        .map(candidate => Object.assign(candidate,
          {
            users: lodash.orderBy(candidate.users, [
              item => item.firstName,
              item => item.lastName,
            ], ['asc', 'asc']),
            name: candidate.name,
            type: candidate.type,
          }))

      this.candidatesDialog = true
    },

    closeCandidatesDialog() {
      this.candidatesDialog = false
    },

    back() {
      if (this.processInfoDialog) {
        this.toggleProcessInfoDialog(false)
      } else {
        this.$router.push('/home')
      }
    },
  },

}
</script>

<style lang="stylus">
.task-status-open
  .v-list__tile--avatar
      border-left 6px solid #4CAF50
.task-status-closed
  .v-list__tile--avatar
      border-left 6px solid #546E7A
.task-status
  border-radius 8px
  .v-avatar
    margin-right 4px
</style>



// WEBPACK FOOTER //
// src/components/process/ProcessInfoTemplate.vue